import React from "react";
import { connect } from "react-redux";
import CommonCard from "./POCommonCard";
import Autocomplete from "react-autocomplete";
import { getShipnameList } from "../Actions/HelpersAPI";
import { getPoSyncExceptionError } from "../Actions/POViewAPI";
import { confirmAlert } from "react-confirm-alert";

class POSyncManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        ShipName: "",
        PageNumber: 1,
        PageSize: 25,
      },
    };
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleInputChanges=this.handleInputChanges.bind(this);
    this.SearchData = this.SearchData.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.renderMovieTitle = this.renderMovieTitle.bind(this);
  }

  componentDidMount() {
    const { match, dispatch } = this.props;
    dispatch({ type: "SubBannerTitle", data: "PO Sync Exceptions" });
    dispatch(getShipnameList());
    dispatch(getPoSyncExceptionError(this.state.searchData));
  }

  handleInputChanges(e, field) {
    this.state.searchData[field] = e.target.value;
    this.setState({});
  }

  handleSelectChange(value, field) {
    this.state.searchData[field] = value;
    this.setState({});
  }

  SearchData(Pgno) {
    this.state.searchData.PageNumber = Pgno;
    this.props.dispatch(getPoSyncExceptionError(this.state.searchData));
  }
  ClearInput() {
    this.state.searchData.ShipName = "";
    this.props.dispatch(getPoSyncExceptionError(this.state.searchData));
    this.setState({});
  }

  hideSidePanel = () => {
    this.props.history.goBack();
    this.props.dispatch({ type: "ShowSidePan", data: false });
  };
  renderMovieTitle(state, val) {
    return state.toLowerCase().indexOf(val.toLowerCase()) !== -1;
  }

  render() {
    const { showSidePane, POSyncErrors, ShipList } = this.props;
    const { flagList } = this.state;
    return (
      <div className="full-height">
        <button
          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3"
          onClick={() => this.hideSidePanel()}
        >
          &larr; Back
        </button>
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-12">
                  <div className="panel-box">
                    <div
                      className=" card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1E3A8A",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-2 mt-2"
                          style={{ color: "092a51" }}
                        >
                          PO Sync Exceptions
                        </h5>
                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row pb-3">
                        <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 pl-2 prd-3 prm-3">
                          <label className="form-label">Ship Name</label>
                          <br></br>
                          <Autocomplete
                            value={this.state.searchData.ShipName}
                            items={ShipList ?? []}
                            getItemValue={(item) => item}
                            renderInput={(props) => {
                              return (
                                <input
                                  className="form-control"
                                  id="exampleFormControlInput23"
                                  placeholder="Ship Name"
                                  {...props}
                                />
                              );
                            }}
                            shouldItemRender={this.renderMovieTitle.bind(this)}
                            renderMenu={(item) => (
                              <div className="dropdowns">{item}</div>
                            )}
                            renderItem={(item, isHighlighted) => (
                              <div
                                className={`items ${
                                  isHighlighted ? "selected-items" : ""
                                }`}
                              >
                                {item}
                              </div>
                            )}
                            onChange={(e, field) =>
                              this.handleInputChanges(e, "ShipName")
                            }
                            onSelect={(value) =>
                              this.handleSelectChange(value, "ShipName")
                            }
                          />
                        </div>

                        <div className={showSidePane ? "col-lg-8" : "col-lg-8"}>
                          <label className="mt-4"></label>
                          <br></br>
                          <div
                            className="search-btn-col"
                            style={{ textAlign: "end" }}
                          >
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit"
                              onClick={() => this.SearchData(1)}
                            >
                              {" "}
                              Search{" "}
                            </button>

                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.ClearInput()}
                            >
                              {" "}
                              Clear{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {POSyncErrors ? (
                <CommonCard
                  arraylist={POSyncErrors.data}
                  pageSize={POSyncErrors.pagination.pageSize}
                  currentPage={POSyncErrors.pagination.currentPage}
                  totalRecords={
                    POSyncErrors.pagination.totalcount
                      ? POSyncErrors.pagination.totalcount
                      : 0
                  }
                  setUpdatedState={(value) => this.SearchData(value)}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    POSyncErrors: state.POViewReducer.POSyncErrors,
    ShipList: state.UserManageReducer.ShipNameList,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(POSyncManagement);
